module.exports = __webpack_public_path__ + "static/media/uib8.727f3cf9.png";